<template>
  <div class="joinPage">
    <Headers></Headers>
    <div class="joinPage-center">
      <div class="page_header">
        <div class="header_title">
          <div class="title_text">{{ listData.name }}</div>
          <div class="title_salary">{{ listData.salary_range }}</div>
        </div>
        <div class="header_address">
          <span>{{ address[1] }}</span> /
          <span>{{ listData.work_year }}</span> /
          <span>{{ listData.education }}</span>
        </div>
        <p>发布于 {{ listData.createtime }}</p>
      </div>
      <div class="page_list">
        <div class="list_intro">
          <h3>职位描述</h3>
          <div id="intro" v-html="listData.content"></div>
          <!-- <ul>一、岗位内容：
            <li>1、负责课程方向的内容体系规划建设；</li>

            <li>2、挖掘用户需求，完善公司课程体系，负责新课程的研发和推进落地；</li>
            
            <li>3、负责录制视频的后期简单剪辑工作；</li>
            
            <li>4、参与线上课堂的运营，收集用户意见，进行课程优化更新；</li>
            
            <li>5、完成上级安排的其他工作。</li>
            
          </ul>
      
          <ul>二、岗位要求：

            <li>1、本科及以上学历，1年以上课程内容运营相关工作经验，有在线教育经验优先；</li>

            <li>2、需要细心和强烈的责任心</li>
            
            <li>3、具备良好的逻辑思维能力和数据挖掘能力；</li>
            
            <li>4、有较强的用户思维，具备良好的运营策划能力，熟悉课程运营模式，善于整合各类资源达成目标；</li>
            
            <li>5、热爱教育行业，有一定的教研能力，有持续学习能力，工作积极主动；</li>
            
            <li>6、能独当一面，有上进心，具有良好的沟通能力和团队合作精神；</li>
            
          </ul> -->
        </div>
        <div class="list_address">
          <h3>工作地点</h3>

          <p>{{ address[0] }} - {{ address[1] }} - {{ address[2] }}</p>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "joinus",
  data() {
    return {
      listData: [],
      address: [],
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
  },
  methods: {},
  mounted() {},
  async created() {
    let _this = this;
    let id = this.$route.params.id || localStorage.jobId;
    // console.log(id)

    _this.$ajax
      .get("https://site.musicwow.com/api/v1/job/details/id/" + id)
      .then((res) => {
        // console.log(res)
        _this.listData = res.data.data;
        _this.address = _this.listData.address.split("/");
        // console.log(_this.listData)
      })
      .catch((res) => {
        // console.log(res);
      });
  },
};
</script>
<style lang="scss" scoped>
.joinPage-center {
  padding-top: 70px;
  // margin: 20px;
  .page_header {
    line-height: 26px;
    border-bottom: 1px solid #ccc3;
    padding: 20px;
    .header_title {
      display: flex;
      margin-bottom: 10px;
      .title_text {
        font-size: 22px;
        font-weight: 700;
      }
      .title_salary {
        margin-left: auto;
        color: #fd5f39;
        font-size: 16px;
      }
    }
    .header_address {
      text-align: left;
      font-size: 14px;
    }
    p {
      color: #999;
      font-size: 12px;
      text-align: left;
    }
  }

  .page_list {
    text-align: left;
    color: #999;
    padding: 20px;
    h3 {
      font-size: 16px;
      font-weight: 600;
      color: #000;
      margin-bottom: 15px;
    }
    ul {
      line-height: 25px;
    }
    .list_address {
      padding: 20px 0;
      p {
        color: #00b38a;
      }
    }
    .list_intro {
      padding: 20px 0;
      border-bottom: 1px solid #ccc3;
    }
  }
}
</style>

